export const FETCH_CONSENT_HUB_LINK = 'mac/FETCH_CONSENT_HUB_LINK';
